import { Link, useLocation } from "react-router-dom";
import { useState, useCallback } from "react";
import LogoutModal from "../modals/LogoutModal";

const Sidebar = ({ setToggle }) => {
  const [show, setShow] = useState(false);
  const location = useLocation();

  const handleLogoutClick = useCallback((e) => {
    e.preventDefault();
    setShow(true);
  }, []);
  return (
    <>
      <aside>
        <div className="sidebar">
          <div className="logo-side ps-2">
            <div className="sidebar-header">
              <Link to="/dashboard">
                <h2>CREATIFY</h2>
              </Link>
              <button
                className="sidebar-close-btn d-xl-none"
                onClick={() => setToggle(false)}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="side-menu">
            <div>
              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/dashboard")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/dashboard"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M17.4167 7.98417L12.5281 4.18184C11.6456 3.49523 10.4095 3.49523 9.52696 4.18184L4.63746 7.98417C4.042 8.44724 3.69386 9.15943 3.69421 9.91376V16.5138C3.69421 17.5263 4.51503 18.3471 5.52755 18.3471H16.5275C17.5401 18.3471 18.3609 17.5263 18.3609 16.5138V9.91376C18.3609 9.15934 18.0125 8.44709 17.4167 7.98417"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.6667 13.7499C12.6409 14.9718 9.35737 14.9718 7.33337 13.7499"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <p>Dashboard</p>
                </Link>
              </div>
              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/influencers")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/influencers"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M11 11C13.7614 11 16 8.76142 16 6C16 3.23858 13.7614 1 11 1C8.23858 1 6 3.23858 6 6C6 8.76142 8.23858 11 11 11Z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21 21V19C21 17.9391 20.5786 16.9217 19.8284 16.1716C19.0783 15.4214 18.0609 15 17 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>Influencers</p>
                </Link>
              </div>
              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/instagram")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/instagram"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M15.5833 2.75H6.41667C4.39162 2.75 2.75 4.39162 2.75 6.41667V15.5833C2.75 17.6084 4.39162 19.25 6.41667 19.25H15.5833C17.6084 19.25 19.25 17.6084 19.25 15.5833V6.41667C19.25 4.39162 17.6084 2.75 15.5833 2.75Z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11 14.6667C13.0251 14.6667 14.6667 13.0251 14.6667 11C14.6667 8.97496 13.0251 7.33334 11 7.33334C8.97496 7.33334 7.33334 8.97496 7.33334 11C7.33334 13.0251 8.97496 14.6667 11 14.6667Z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15.9517 6.41667H15.9608"
                      stroke="#2F2B3D"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>Instagram</p>
                </Link>
              </div>
              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/tikTok")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/tikTok"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M19.321 5.562a5.124 5.124 0 0 1-.443-.467h.005A5.495 5.495 0 0 1 17.5 1.75h-3.491v13.943c0 1.53-1.244 2.777-2.777 2.777a2.777 2.777 0 0 1-2.777-2.777 2.777 2.777 0 0 1 2.777-2.777c.307 0 .601.051.877.145v-3.509a6.297 6.297 0 0 0-.877-.061c-3.408 0-6.172 2.764-6.172 6.172s2.764 6.172 6.172 6.172c3.408 0 6.172-2.764 6.172-6.172V8.455a9.17 9.17 0 0 0 5.483 1.812V6.766a5.496 5.496 0 0 1-3.566-1.204z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>{" "}
                  <p>Tik Tok</p>
                </Link>
              </div>

              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/x")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/x"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>{" "}
                  <p>X</p>
                </Link>
              </div>

              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/youtube")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/youtube"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.75 15.02l5.75-3.27-5.75-3.27v6.54z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>{" "}
                  <p>Youtube</p>
                </Link>
              </div>
              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/facebook")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/facebook"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M15.5833 2.75H6.41667C4.39162 2.75 2.75 4.39162 2.75 6.41667V15.5833C2.75 17.6084 4.39162 19.25 6.41667 19.25H15.5833C17.6084 19.25 19.25 17.6084 19.25 15.5833V6.41667C19.25 4.39162 17.6084 2.75 15.5833 2.75Z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />

                    <path
                      d="M12.8333 19.25V11.9167H14.6667L15 8.25H12.8333V6.41667C12.8333 5.68334 13.2 5.5 13.75 5.5H15V2.75H12.8333C10.8083 2.75 9.16667 4.39162 9.16667 6.41667V8.25H7.33334V11.9167H9.16667V19.25H12.8333Z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>Facebook</p>
                </Link>
              </div>
              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/custom/image")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/custom/image"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M13.7499 7.33333H13.7591"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="3.66663"
                      y="3.66667"
                      width="14.6667"
                      height="14.6667"
                      rx="3"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.66663 13.75L7.33329 10.0833C8.18415 9.26455 9.23244 9.26455 10.0833 10.0833L14.6666 14.6666"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12.8334 12.8333L13.75 11.9166C14.6009 11.0979 15.6492 11.0979 16.5 11.9166L18.3334 13.75"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>Custom Image</p>
                </Link>
              </div>

              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/custom/video")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/custom/video"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M13.75 9.16678L17.9236 7.08044C18.2077 6.93849 18.545 6.95368 18.8151 7.1206C19.0853 7.28751 19.2498 7.58237 19.25 7.89994V14.1003C19.2498 14.4178 19.0853 14.7127 18.8151 14.8796C18.545 15.0465 18.2077 15.0617 17.9236 14.9198L13.75 12.8334V9.16678Z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="2.75"
                      y="5.5"
                      width="11"
                      height="11"
                      rx="2"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <p>Custom Video</p>
                </Link>
              </div>
              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/gallery")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/gallery"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M8.24996 3.66667H11L12.8333 5.5H17.4166C18.4291 5.5 19.25 6.32081 19.25 7.33333V13.75C19.25 14.7625 18.4291 15.5833 17.4166 15.5833H8.24996C7.23744 15.5833 6.41663 14.7625 6.41663 13.75V5.5C6.41663 4.48748 7.23744 3.66667 8.24996 3.66667"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15.5833 15.5833V17.4167C15.5833 18.4292 14.7625 19.25 13.75 19.25H4.58333C3.57081 19.25 2.75 18.4292 2.75 17.4167V9.16667C2.75 8.15414 3.57081 7.33333 4.58333 7.33333H6.41667"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <p>Gallery</p>
                </Link>
              </div>
              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/persona-management")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  to="/persona-management"
                  onClick={() => setToggle(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M11 11C13.7614 11 16 8.76142 16 6C16 3.23858 13.7614 1 11 1C8.23858 1 6 3.23858 6 6C6 8.76142 8.23858 11 11 11Z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17.5 21H4.5C3.11929 21 2 19.8807 2 18.5V17.5C2 14.4624 4.46243 12 7.5 12H14.5C17.5376 12 20 14.4624 20 17.5V18.5C20 19.8807 18.8807 21 17.5 21Z"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>Persona Management</p>
                </Link>
              </div>

              <div className="side-btm-space">
                <Link
                  className={
                    location.pathname.includes("/logout")
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                  onClick={handleLogoutClick}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M12.8333 7.33333V5.5C12.8333 4.48748 12.0125 3.66667 11 3.66667H4.58333C3.57081 3.66667 2.75 4.48748 2.75 5.5V16.5C2.75 17.5125 3.57081 18.3333 4.58333 18.3333H11C12.0125 18.3333 12.8333 17.5125 12.8333 16.5V14.6667"
                      stroke="#2F2B3D"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.41663 10.25C6.00241 10.25 5.66663 10.5858 5.66663 11C5.66663 11.4142 6.00241 11.75 6.41663 11.75V11V10.25ZM19.25 11V11.75C19.5533 11.75 19.8268 11.5673 19.9429 11.287C20.059 11.0068 19.9948 10.6842 19.7803 10.4697L19.25 11ZM17.0303 7.71967C16.7374 7.42678 16.2625 7.42678 15.9696 7.71967C15.6767 8.01256 15.6767 8.48744 15.9696 8.78033L16.5 8.25L17.0303 7.71967ZM15.9696 13.2197C15.6767 13.5126 15.6767 13.9874 15.9696 14.2803C16.2625 14.5732 16.7374 14.5732 17.0303 14.2803L16.5 13.75L15.9696 13.2197ZM19.7803 11.5303C20.0732 11.2374 20.0732 10.7626 19.7803 10.4697C19.4874 10.1768 19.0125 10.1768 18.7196 10.4697L19.25 11L19.7803 11.5303ZM6.41663 11V11.75H19.25V11V10.25H6.41663V11ZM19.25 11L19.7803 10.4697L17.0303 7.71967L16.5 8.25L15.9696 8.78033L18.7196 11.5303L19.25 11ZM16.5 13.75L17.0303 14.2803L19.7803 11.5303L19.25 11L18.7196 10.4697L15.9696 13.2197L16.5 13.75Z"
                      fill="#2F2B3D"
                    />
                  </svg>
                  <p>Logout</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <LogoutModal show={show} hide={() => setShow(false)} />
      </aside>
    </>
  );
};
export default Sidebar;
